const state = {
    stripe: window.Stripe(process.env.VUE_APP_STRIPE_KEY),
    card: null,
}

const getters = {

    stripe: state => {
        return state.stripe;
    },

    card: state => {
        return state.card;
    },

}

const mutations = {

    setCard(state, card) {
        state.card = card;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}